import React, { Fragment } from 'react';

import { GliderItem, IGliderItem } from '../../atoms';
import { IGliderComponent } from '../glider-wrapper/glider-wrapper';

export type MenuGliderItemsVariant = 'mgv' | 'wide';

export interface IMenuGliderItems extends IGliderComponent<MenuGliderItemsVariant> {
  items?: IGliderItem[];
  isSSR?: boolean;
}

const getMenuList = (params: {
  items?: IGliderItem[];
  activeSlideIndex?: number;
  onItemSelectedCallback?: (id: number) => void;
}) => {
  const { items = [], activeSlideIndex = 0, onItemSelectedCallback } = params;

  return items?.map((item, index) => (
    <GliderItem
      key={index}
      {...item}
      onItemSelectedCallback={onItemSelectedCallback}
      itemState={index === activeSlideIndex ? 'focused' : item.itemState}
    />
  ));
};

const MenuGliderItems: React.FC<IMenuGliderItems> = ({
  isSSR = false,
  items,
  activeSlideIndex,
  onItemSelectedCallback,
}) => {
  const menuList = getMenuList({ items, activeSlideIndex, onItemSelectedCallback });

  return isSSR ? (
    <div className="glider-wrapper glider-wrapper--ccr glider-wrapper--ssr">
      <div className="glider-contain">
        <div className="glider-component glider">
          <div className="glider-track--custom glider-track">{menuList}</div>
        </div>
      </div>
    </div>
  ) : (
    <Fragment>{menuList}</Fragment>
  );
};

export default MenuGliderItems;
